import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import useFavoriteItemMutation from "hooks/useFavoriteItemMutation";
import CommonFavoriteIcon from "views/components/common/CommonFavoriteIcon";
const FavoriteIcon = ({ isFavorite, grn, onChange, className = void 0 }) => {
  const { t } = useTranslation("search");
  const { putItem, deleteItem } = useFavoriteItemMutation();
  const onClick = useCallback(() => {
    if (isFavorite) {
      deleteItem(grn).then(() => onChange(false));
    } else {
      putItem(grn).then(() => onChange(true));
    }
  }, [isFavorite, deleteItem, grn, onChange, putItem]);
  const title = isFavorite ? t("common_views.remove_from_favorites") : t("common_views.add_to_favorites");
  return /* @__PURE__ */ React.createElement(CommonFavoriteIcon, { className, onClick, title, isFavorite });
};
export default FavoriteIcon;
